/**
 * Zgoda na cookies z banera WPConsent (wtyczka WP na volubus.com).
 *
 * WPConsent zapisuje wybór w cookie `wpconsent_preferences` jako JSON
 * `{"essential":true,"statistics":false,"marketing":true}` (slugi kategorii)
 * i emituje na `window` zdarzenie `wpconsent_consent_saved` z tym samym obiektem w `detail`.
 * Cookies first-touch (`vlb_utms`) i Impact (`impact_im_ref`) należą do kategorii `marketing`.
 */
import { getCookie } from './utils';

const CONSENT_COOKIE = 'wpconsent_preferences';
const CONSENT_EVENT = 'wpconsent_consent_saved';
const MARKETING_CATEGORY = 'marketing';

type ConsentPreferences = Record<string, unknown>;

function parsePreferences(raw: string): ConsentPreferences | null {
  for (const candidate of [raw, safeDecode(raw)]) {
    if (!candidate) continue;
    try {
      const parsed = JSON.parse(candidate);
      if (parsed && typeof parsed === 'object') return parsed as ConsentPreferences;
    } catch {
      // następny wariant
    }
  }
  return null;
}

function safeDecode(raw: string): string {
  try {
    return decodeURIComponent(raw);
  } catch {
    return '';
  }
}

/** Czy odwiedzający zgodził się na kategorię marketing. Brak decyzji = brak zgody. */
export function hasMarketingConsent(): boolean {
  const raw = getCookie(CONSENT_COOKIE);
  if (!raw) return false;
  const prefs = parsePreferences(raw);
  return prefs?.[MARKETING_CATEGORY] === true;
}

/** Wywołuje `callback`, gdy odwiedzający zapisze zgodę obejmującą marketing (bez przeładowania strony). */
export function onMarketingConsentGranted(callback: () => void): void {
  if (typeof window.addEventListener !== 'function') return;
  window.addEventListener(CONSENT_EVENT, (event: Event) => {
    const detail = (event as CustomEvent<ConsentPreferences>).detail;
    if (detail && detail[MARKETING_CATEGORY] === true) callback();
  });
}
